import { findFund } from "../../../component/Methods";

export function fundLabel(id, data, funds) {
  if (data && typeof data === "object") {
    if (data.name) return String(data.name);
    if (data.abbreviation) return String(data.abbreviation);
  }
  const fromStore = findFund(id, funds);
  return fromStore || "—";
}

export function smaLabel(id, data) {
  if (data && typeof data === "object") {
    if (data.name) return String(data.name);
    if (data.abbreviation) return String(data.abbreviation);
  }
  return "—";
}

/** Backend sometimes sends `0` for “unset” type; show the row-kind label instead. */
export function fundSmaTypeCellLabel(kind, data) {
  const fallback = kind === "fund" ? "Fund" : "SMA";
  const t = data && typeof data === "object" ? data.type : undefined;
  if (t == null) return fallback;
  if (t === 0 || t === "0") return fallback;
  if (typeof t === "string" && t.trim() === "") return fallback;
  return String(t);
}

export function extractFundId(data, index) {
  if (typeof data === "string") return data;
  if (data && typeof data === "object") {
    return data.fundId ?? data.id ?? data.fund ?? String(index);
  }
  return String(index);
}

export function extractSmaId(data, index) {
  if (typeof data === "string") return data;
  if (data && typeof data === "object") {
    return data.smaId ?? data.fundId ?? data.id ?? data.sma ?? String(index);
  }
  return String(index);
}
